import { Html, useProgress } from '@react-three/drei';
import { ThemeContext } from '../context/ThemeContext';
import { useContext } from 'react';

const CanvasLoader = () => {
  const { progress } = useProgress();
  const { darkMode } = useContext(ThemeContext);
  
  return (
    <Html
      as="div"
      center
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <span className="canvas-loader"></span>
      <p
        style={{
          fontSize: 14,
          color: darkMode ? '#F1F1F1' : 'black',
          fontWeight: 800,
          marginTop: 40,
        }}>
        {progress !== 0 ? `${progress.toFixed(2)}%` : 'Loading 3D Models. Please wait...'}
      </p>
    </Html>
  );
};

export default CanvasLoader;